import { render, staticRenderFns } from "./DonutPieChart.vue?vue&type=template&id=f430dd30&"
import script from "./DonutPieChart.vue?vue&type=script&lang=js&"
export * from "./DonutPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports